import {
    register,
    CloudObject,
    Tag,
    Transaction,
    defineProperty,
    defineRelation,
    Direction,
} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class Roles extends CloudObject {
    /**
     * Creates an instance of Roles.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(Roles);
    }

    /**
     * @return {string}
     */
    getRoleValue() {
        return this.get(Roles.roleValueProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeRoleValue($) {
        return this.observe($, Roles.roleValueProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setRoleValue(transaction, instance, value) {
        transaction.update(instance, Roles.roleValueProp, value);
    }
}

// Hardcoded tags
register('01881ebcb562d0ac4cd5', Roles);
Roles.roleValueProp = defineProperty('01881f86397ea8af3872');
Roles.inverse_andritzUserroleRel = defineRelation('01881f860ffc35b87099', Direction.ORIGIN);
